import type { INoContentBlockProps } from './NoContentBlock'

import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'

export const NoContentBlockSC = styled.div<
  Omit<INoContentBlockProps, 'width' | 'height'> & {
    blockWidth?: string
    blockHeight?: string
  }
>`
  display: flex;
  width: ${({ blockWidth }) => blockWidth ?? 'initial'};
  height: ${({ blockHeight }) => blockHeight ?? 'initial'};
  flex-direction: ${({ direction }) => direction ?? 'initial'};
  align-items: ${({ alignItems }) => alignItems ?? 'initial'};
  justify-content: ${({ justifyContent }) => justifyContent ?? 'initial'};
  flex-grow: ${({ flexGrow }) => flexGrow ?? 'initial'};
  padding: ${({ paddings }) => (paddings?.length ? `var(${paddings}) ` : 0)};
  ${IconSC} {
    font-size: ${({ iconSize }) => `var(${iconSize})`};
  }
  ${IconSC} + ${TextBoxSC} {
    margin-top: 12px;
  }
`
